import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "pagination"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { onMounted, onUnmounted, ref } from "vue";
import { httpGet, httpPost, httpPostDownload } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, substr, UUID } from "@/utils/libs";
import { DocumentCopy, Plus, Search } from "@element-plus/icons-vue";
import { showMessageError } from "@/utils/dialog";
import ClipboardJS from "clipboard";

// 变量定义

export default {
  __name: 'Redeem',
  setup(__props) {
    const items = ref([]);
    const loading = ref(true);
    const query = ref({
      code: "",
      status: -1
    });
    const redeemStatus = ref([{
      value: -1,
      label: "全部"
    }, {
      value: 0,
      label: "未核销"
    }, {
      value: 1,
      label: "已核销"
    }]);
    const showDialog = ref(false);
    const dialogLoading = ref(false);
    const item = ref({
      name: "",
      power: 0,
      num: 1
    });
    const itemIds = ref([]);
    const exporting = ref(false);
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new ClipboardJS(".copy-code");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
      fetchData();
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const add = () => {
      item.value = {
        name: "100算力点卡",
        power: 100,
        num: 1
      };
      showDialog.value = true;
      dialogLoading.value = false;
    };
    const save = () => {
      if (item.value.name === "") {
        return showMessageError("请输入兑换码名称");
      }
      if (item.value.power === 0) {
        return showMessageError("请输入算力额度");
      }
      if (item.value.num <= 0) {
        return showMessageError("请输入生成数量");
      }
      dialogLoading.value = true;
      httpPost("/admin/redeem/create", item.value).then(res => {
        ElMessage.success(`成功生成了${res.data.counter}个兑换码`);
        showDialog.value = false;
        fetchData();
      }).catch(e => {
        ElMessage.error("生成失败：" + e.message);
      });
    };
    const set = (filed, row) => {
      httpPost("/admin/redeem/set", {
        id: row.id,
        filed: filed,
        value: row[filed]
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const page = ref(1);
    const pageSize = ref(12);
    const total = ref(0);
    const fetchData = () => {
      query.value.page = page.value;
      query.value.page_size = pageSize.value;
      httpGet("/admin/redeem/list", query.value).then(res => {
        if (res.data) {
          items.value = res.data.items;
          total.value = res.data.total;
          page.value = res.data.page;
          pageSize.value = res.data.page_size;
        }
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet("/admin/redeem/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        fetchData();
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    const handleSelectionChange = items => {
      itemIds.value = items.map(item => item.id);
    };
    const exportItems = () => {
      query.value.ids = itemIds.value;
      exporting.value = true;
      httpPostDownload("/admin/redeem/export", query.value).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", UUID() + ".csv"); // 设置下载文件的名称
        document.body.appendChild(link);
        link.click();

        // 移除 <a> 标签
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        exporting.value = false;
      }).catch(() => {
        exporting.value = false;
        showMessageError("下载失败");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: query.value.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.code = $event),
        placeholder: "兑换码",
        class: "handle-input mr10"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: query.value.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.value.status = $event),
        placeholder: "核销状态",
        style: {
          "width": "100px"
        },
        class: "handle-input mr10"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(redeemStatus.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        onClick: fetchData
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "success",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("添加兑换码")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: exportItems,
        loading: exporting.value
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("i", {
          class: "iconfont icon-export mr-1"
        }, null, -1), _createTextVNode(" 导出 ")])),
        _: 1
      }, 8, ["loading"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          onSelectionChange: handleSelectionChange,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "38"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称"
          }), _createVNode(_component_el_table_column, {
            prop: "code",
            label: "兑换码"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(substr)(scope.row.code, 24)), 1), _createVNode(_component_el_icon, {
              class: "copy-code",
              "data-clipboard-text": scope.row.code
            }, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 2
            }, 1032, ["data-clipboard-text"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "兑换人"
          }, {
            default: _withCtx(scope => [scope.row['username'] !== '' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row["username"]), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("未兑换")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "power",
            label: "算力"
          }), _createVNode(_component_el_table_column, {
            label: "生成时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "兑换时间"
          }, {
            default: _withCtx(scope => [scope.row['redeemed_at'] > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(dateFormat)(scope.row["redeemed_at"])), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("未兑换")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => set('enabled', scope.row),
              disabled: scope.row['redeemed_at'] > 0
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row)
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "total,prev, pager, next",
        "hide-on-single-page": true,
        "current-page": page.value,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => page.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => pageSize.value = $event),
        onCurrentChange: _cache[4] || (_cache[4] = $event => fetchData()),
        total: total.value
      }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)]), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showDialog.value = $event),
        title: "生成兑换码"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: item.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => item.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "算力额度：",
            prop: "power"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.power,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => item.value.power = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "生成数量：",
            prop: "num"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.num,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => item.value.num = $event),
              modelModifiers: {
                number: true
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])), [[_directive_loading, dialogLoading.value]])]),
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }
};